import Grid from "@material-ui/core/Grid"
import styled from "styled-components"

const FullwidthGrid = styled(Grid)`
  width: 100%;
`

export default FullwidthGrid
